import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { ISiteConfiguration } from 'src/app/feature/admin/models/site-configuration';


export const SiteConfigurationAdapter =
 createEntityAdapter<ISiteConfiguration>({ selectId: (item: ISiteConfiguration) => item.facilityId });

export interface SiteConfigurationState extends EntityState<ISiteConfiguration> {
  selectedConfigurationId: number | null;
  isLoaded: boolean;
}

export const intialSiteConfigurationState: SiteConfigurationState = SiteConfigurationAdapter.getInitialState({
  selectedConfigurationId: null,
  isLoaded: false
});

const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = SiteConfigurationAdapter.getSelectors();

export const selectConfigurationEntities = selectEntities;

export const selectAllConfigurationEntities = selectAll;

export const getSiteConfigurationIsLoaded = (state: SiteConfigurationState) => state.isLoaded;
